export enum WIDGET_TYPE {
  vertical = 'vertical',
  common = 'common',
}
